'use client';

import { useEffect } from 'react';
import { Alert02Icon } from 'hugeicons-react';
import { Button } from '@/core/ui/primitives/button';

export default function AuthError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Auth error:', error);
  }, [error]);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="flex flex-col items-center text-center">
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
          <Alert02Icon className="size-7 text-destructive" />
        </div>
        <h1 className="mb-2 text-lg font-semibold text-foreground">Authentication error</h1>
        <p className="mb-6 max-w-sm text-sm text-muted-foreground">
          Something went wrong during sign in. Please try again.
        </p>
        <div className="flex items-center gap-2">
          <Button size="lg" onClick={reset}>
            Try again
          </Button>
          <Button variant="outline" size="lg" onClick={() => (window.location.href = '/auth/login')}>
            Back to sign in
          </Button>
        </div>
      </div>
    </main>
  );
}
